import { Device, until } from '@helpers/media';
import { withQueryParams } from '@hoc/withQueryParams';
import { withRedux } from '@hoc/withRedux';
import { fetchLocationRanges, fetchLocations } from '@redux/slices/locations';
import { useAppDispatch, useAppSelector } from '@redux/store';
import * as React from 'react';
import { useFirstMountState } from 'react-use';
import { ArrayParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import DetailPanel from './DetailPanel/DetailPanel';
import FilterFull from './FilterFull/FilterFull';
import FilterSimple from './FilterSimple/FilterSimple';
import ListArea from './ListArea/ListArea';
import S from './LocationMap.styles';
import MapArea from './MapArea/MapArea';
const LocationMap = (props) => {
    const isFirstMount = useFirstMountState();
    const refMain = React.useRef(null);
    const refTop = React.useRef(null);
    // Store filter params in query string.
    const [params, setParams] = useQueryParams({
        location: withDefault(StringParam, ''),
        rangesOthers: withDefault(ArrayParam, []),
        rangesSliding: withDefault(ArrayParam, []),
        types: withDefault(ArrayParam, []),
    });
    // Sanitise params from query string, mainly due to awkward array type.
    const paramsSanitized = {
        location: params.location,
        rangesOthers: toStringArray(params.rangesOthers),
        rangesSliding: toStringArray(params.rangesSliding),
        types: toStringArray(params.types),
    };
    const [rangesParams, setRangesParams] = useQueryParams({
        location: withDefault(StringParam, ''),
        rangesOthers: withDefault(ArrayParam, []),
        rangesSliding: withDefault(ArrayParam, []),
        types: withDefault(ArrayParam, []),
    });
    const rangesParamsSanitized = {
        location: rangesParams.location,
        types: toStringArray(rangesParams.types),
    };
    // Get data from redux state.
    const { locations, locationRanges } = useAppSelector((state) => state);
    // Get reference to redux dispatcher.
    const dispatch = useAppDispatch();
    // Dispatch fetch when params change and on mount.
    React.useEffect(() => {
        dispatch(fetchLocations(paramsSanitized));
    }, [JSON.stringify(paramsSanitized)]);
    // Dispatch fetch when params change and on mount.
    React.useEffect(() => {
        dispatch(fetchLocationRanges(rangesParamsSanitized));
    }, [JSON.stringify(rangesParamsSanitized)]);
    // Scroll to top of list on mobile when location is selected.
    React.useEffect(() => {
        if (!locations.selectedLocationId) {
            return;
        }
        if (window.matchMedia(until(Device.TabletLarge)).matches) {
            refMain.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
            });
        }
    }, [locations.selectedLocationId]);
    // Scroll to top of list on mobile when filter is toggled
    React.useEffect(() => {
        if (isFirstMount) {
            return;
        }
        if (window.matchMedia(until(Device.TabletLarge)).matches) {
            refTop.current?.scrollIntoView({
                behavior: 'auto',
                block: 'start',
                inline: 'start',
            });
        }
    }, [locations.filterExpanded]);
    return (React.createElement(S.Container, { id: props.anchorId }, locations.filterExpanded ? (React.createElement(S.Top, { ref: refTop },
        React.createElement(FilterFull, { params: paramsSanitized, rangesOthers: locationRanges.apiData?.rangesOthers ?? [], rangesSlidingWardrobes: locationRanges.apiData?.rangesSlidingWardrobes ?? [], slidingWardrobesId: props.slidingWardrobesId, types: props.types, onSubmit: (value) => setParams(value), onChange: (value) => setRangesParams(value), scrollTop: () => {
                refTop.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'start',
                });
            } }))) : (React.createElement(React.Fragment, null,
        React.createElement(S.Top, { ref: refTop },
            React.createElement(FilterSimple, { params: paramsSanitized, rangesOthers: locationRanges.apiData?.rangesOthers ?? [], slidingWardrobesId: props.slidingWardrobesId, rangesSlidingWardrobes: locationRanges.apiData?.rangesSlidingWardrobes ?? [], types: props.types, onChange: (value) => setParams(value) })),
        React.createElement(S.Main, { ref: refMain },
            React.createElement(S.MainLeft, null, locations.selectedLocationId ? React.createElement(DetailPanel, null) : React.createElement(ListArea, null)),
            React.createElement(S.MainRight, null,
                React.createElement(MapArea, null)))))));
};
export default withRedux(withQueryParams(LocationMap));
/**
 * Convert value to string array.
 * @param value
 * @returns
 */
function toStringArray(value) {
    if (!Array.isArray(value)) {
        return [];
    }
    return value.filter((item) => typeof item === 'string');
}
